<template>
	<div class="m-image-advert flex-center">
		<p v-if="!imageList.length">未添加图片</p>
        <img v-for="(item,i) in imageList" :key="i" :src="item.img_url" :style="{
            'width': item.width,
            'height': item.height,
            'margin-left': item.margin
        }"></img>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imageList: []
			}
		},
		
		methods: {
			set(data) {
				if (!data.list) return;
				data.list = data.list.filter(item => {
					return !!item.img_url;
				});
				function gcd(a, b) {
					if (b == 0) {
						return a;
					}
					var r = a % b;
					return gcd(b, r);
				}
				function scm(a, b) {
					return (a * b) / gcd(a, b);
				}
				
				var num = 1;  // 最小公倍数
				var col = 0;
				data.list.forEach(function(item) {
					num = scm(num, item.img_height);
				});
				data.list.forEach(function(item) {
					item.width = item.img_width * parseInt(num / item.img_height);
					item.height = num;
					col += item.width;
				});
				
				var width = 375 - (data.is_margin == 1 ? 24 : 0) - (data.is_padding == 1 ? 10 * (data.list.length - 1) : 0);
				var unit = width / col;
				data.list.forEach(function(item, i) {
					item.width = Math.ceil(item.width * unit) + 'px';
					item.height = Math.ceil(item.height * unit) + 'px';
					item.margin = i > 0 && data.is_padding == 1 ? '10px' : 0;
				});
				
				this.imageList = data.list;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-image-advert {
		font-size: 0;
		
		p {
			line-height: 40px;
			font-size: 12px;
			text-align: center;
			color: #999;
		}
	}
</style>
